'use strict';

module.exports = require('./LM');
module.exports.Matrix = require('ml-matrix');
module.exports.Matrix.algebra = require('./algebra');
